/* eslint-disable consistent-return */
import React, { memo, Suspense, useCallback, useEffect, useState } from 'react';

import ContainerLayout from '@wconcept/wconcept-ui-renewal/components/layouts/ContainerLayout';
import ActionbarLayout from '@wconcept/wconcept-ui-renewal/components/layouts/ActionbarLayout';
import Header from '@wconcept/wconcept-ui-renewal/components/organisms/_header/Header';
// import Actionbar from '@wconcept/wconcept-ui-renewal/components/organisms/Actionbar';
import TopBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/TopBtn';
import TopBtnOld from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/TopBtnOld';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import { BiLogo } from '@wconcept/wconcept-common/models/renewal/popup';
import { checkAppVersion } from '@wconcept/wconcept-common/utils/userAgentUtil';

import * as S from './style';

interface IProps {
  /** className */
  className?: string;
  /** children */
  children?: React.ReactNode;
  /** title */
  title?: string;
  /** titleNode - title 대신 ReactNode를 렌더링할 때 사용 */
  titleNode?: React.ReactNode;
  /** headerType */
  headerType?: 'main' | 'subPage' | 'subDetail' | undefined;
  /** headerBgType */
  headerBgType?: 'white' | 'black' | 'transparent' | undefined;
  /** actionbarBgType */
  actionbarBgType?: 'white' | 'black' | undefined;
  /** actionbarActive */
  actionbarActive?: string;
  /** isActionBar */
  isActionBar?: boolean;
  /** isLogin */
  isLogin?: boolean;
  /** isTopBtn */
  isTopBtn?: boolean;
  /** isHistoryBtn */
  isHistoryBtn?: boolean;
  /** isStyleClipAddBtn */
  isStyleClipAddBtn?: boolean;
  /** isShortFormBtn */
  isShortFormBtn?: boolean | 'simple';
  /** isShortFormSimpleBtn */
  isShortFormSimpleBtn?: boolean;
  /** isProfileBtn */
  isProfileBtn?: boolean;
  /** isSearchBtn */
  isSearchBtn?: boolean;
  /** isCartBtn */
  isCartBtn?: boolean;
  /** isShareBtn */
  isShareBtn?: boolean;
  /** isNativeAppBoth */
  isNativeAppBoth?: boolean;
  /** isIPhoneXApp */
  isIPhoneXApp?: boolean;
  /** basketCount */
  basketCount?: number;
  /** historyImg */
  historyImg?: string;
  /** isShortFormBtnTooltip */
  isShortFormBtnTooltip?: boolean;
  /** setTooltipShown */
  setTooltipShown?: (value: string) => void;
  shareItem?: React.ReactNode;
  viewProductBtn?: React.ReactNode;
  transparentHeader?: boolean;
  appVersion?: string;
  logoInfo?: BiLogo;
  historyBtnRs?: string;
  styleClipTooltipPoint?: number;
  eventType?: string;
  /** getHistoryImg */
  getHistoryImg?: () => void;
  /** onClickTop */
  onClickTop?: () => void;
  /** onClickShortForm */
  onClickShortForm?: () => void;
  /** onClickProfileBtn */
  onClickProfileBtn?: () => void;
  /** onClickHomeBtn */
  onClickHomeBtn?: () => void;
  /** onClickAlarmBtn */
  onClickAlarmBtn?: () => void;
  /** onClickSearchBtn */
  onClickSearchBtn?: () => void;
  /** onClickCartBtn */
  onClickCartBtn?: () => void;
  /** onClickHome */
  onClickHome?: () => void;
  /** onClickCate */
  onClickCate?: () => void;
  /** onClickDiscovery */
  // onClickDiscovery?: () => void;
  /** onClickMypage */
  onClickMypage?: () => void;
  /** onClickMyheart */
  onClickMyheart?: () => void;
  /** onClickBackBtn */
  onClickBackBtn?: () => void;
  /** onClickStyleClipAddBtn */
  onClickStyleClipAddBtn?: () => void;
  /** onClickHistory */
  onClickHistory?: () => void;
  /** onClickShare */
  onClickShare?: () => Promise<void>;
  /** onClickSearch */
  onClickSearch?: () => void;
  /** onClickLogoBtn */
  onClickLogoBtn?: () => void;
}

const SubLayout = ({
  className,
  children,
  title,
  titleNode,
  headerType,
  headerBgType,
  actionbarBgType,
  isActionBar = true,
  actionbarActive,
  appVersion,
  historyImg,
  isLogin,
  historyBtnRs,
  isTopBtn,
  isHistoryBtn,
  eventType,
  isStyleClipAddBtn,
  isProfileBtn,
  isSearchBtn,
  isCartBtn,
  isShortFormBtn,
  isShortFormSimpleBtn,
  isShareBtn,
  isNativeAppBoth,
  isIPhoneXApp,
  basketCount,
  isShortFormBtnTooltip,
  setTooltipShown,
  styleClipTooltipPoint,
  getHistoryImg,
  shareItem,
  viewProductBtn,
  transparentHeader = false,
  logoInfo,
  onClickTop,
  onClickShortForm,
  onClickProfileBtn,
  onClickHomeBtn,
  onClickAlarmBtn,
  onClickSearchBtn,
  onClickCartBtn,
  onClickHome,
  onClickCate,
  // onClickDiscovery,
  onClickSearch,
  onClickMypage,
  onClickMyheart,
  onClickBackBtn,
  onClickStyleClipAddBtn,
  onClickHistory,
  onClickShare,
  onClickLogoBtn,
}: IProps) => {
  const [btnTopShow, setBtnTopShow] = useState<boolean>(false);
  const [isFixHeader, setIsFixHeader] = useState<boolean>(false);
  const [cName, setClassName] = useState<string>(
    classNameBind([
      'sub-layout',
      isNativeAppBoth ? 'is-app' : '',
      isIPhoneXApp ? 'is-old-app-iphonex' : '',
      className || '',
      transparentHeader ? 'transparent-header' : '',
    ])
  );
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    if (shareItem || transparentHeader) {
      const handleScroll = () => {
        const scrollYPos = window.pageYOffset;
        setScrollY(scrollYPos);
      };

      window.addEventListener('scroll', handleScroll);
      handleScroll();
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, [shareItem, transparentHeader]);

  // 기획전에 사용하는 탑버튼, 투명헤더 스크롤 관련
  useEffect(() => {
    if (shareItem || transparentHeader) {
      const windowH = window.innerHeight;
      const headerEl = document.getElementById('header');
      const header = headerEl?.getBoundingClientRect();
      const headerOfsTop = headerEl?.offsetTop ?? 0;

      // 기획전 탑버튼 노출
      if (scrollY > windowH * 0.6) {
        setBtnTopShow(true);
      } else {
        setBtnTopShow(false);
      }

      // 헤더 fix 모드
      const headerHeight = header?.height || 0;

      if (scrollY > headerHeight + headerOfsTop) {
        setIsFixHeader(true);
      } else if (scrollY <= headerOfsTop) {
        setIsFixHeader(false);
      }
    }
  }, [scrollY, shareItem, transparentHeader]);

  useEffect(() => {
    setClassName(
      classNameBind([
        'sub-layout',
        isNativeAppBoth ? 'is-app' : '',
        isIPhoneXApp ? 'is-old-app-iphonex' : '',
        isFixHeader ? 'is-fix-header' : '',
        transparentHeader ? 'transparent-header' : '',
        className || '',
      ])
    );
  }, [
    className,
    isFixHeader,
    isIPhoneXApp,
    isNativeAppBoth,
    transparentHeader,
  ]);

  const handleScrollTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const getTopBtn = () => {
    if (isNativeAppBoth) {
      const version = appVersion;
      if (checkAppVersion(version, '7.0.0') === 'low') {
        return (
          <TopBtnOld
            className={`btn-top ${btnTopShow ? ' active' : ''}`}
            onClick={handleScrollTop}
          />
        );
      }
    }
    return (
      <TopBtn
        className={`btn-top ${btnTopShow ? ' active' : ''}`}
        onClick={handleScrollTop}
      />
    );
  };

  return (
    <S.SubLayout className={cName}>
      <Header
        logoInfo={logoInfo}
        bgType={headerBgType}
        basketCount={basketCount}
        title={title}
        titleNode={titleNode}
        type={headerType}
        isProfileBtn={isProfileBtn}
        isSearchBtn={isSearchBtn}
        isCartBtn={isCartBtn}
        onClickProfileBtn={onClickProfileBtn}
        onClickHomeBtn={onClickHomeBtn}
        onClickAlarmBtn={onClickAlarmBtn}
        onClickSearchBtn={onClickSearchBtn}
        onClickCartBtn={onClickCartBtn}
        onClickBackBtn={onClickBackBtn}
        onClickLogoBtn={onClickLogoBtn}
      />
      <ContainerLayout>
        {children}
        {viewProductBtn}
        {shareItem && getTopBtn()}
        {shareItem}
      </ContainerLayout>
      {isActionBar && (
        <ActionbarLayout
          active={actionbarActive}
          bgType={actionbarBgType}
          isTopBtn={isTopBtn}
          isHistoryBtn={isHistoryBtn}
          isStyleClipAddBtn={isStyleClipAddBtn}
          isShortFormBtn={isShortFormBtn}
          isShortFormSimpleBtn={isShortFormSimpleBtn}
          isShareBtn={isShareBtn}
          isNativeAppBoth={isNativeAppBoth || false}
          isIPhoneXApp={isIPhoneXApp || false}
          historyImg={historyImg}
          isShortFormBtnTooltip={isShortFormBtnTooltip}
          setTooltipShown={setTooltipShown}
          appVersion={appVersion || ''}
          styleClipTooltipPoint={styleClipTooltipPoint}
          getHistoryImg={getHistoryImg}
          onClickTop={onClickTop}
          onClickShortForm={onClickShortForm}
          onClickHome={onClickHome}
          onClickCate={onClickCate}
          onClickSearch={onClickSearch}
          onClickMyheart={onClickMyheart}
          onClickMypage={onClickMypage}
          onClickStyleClipAddBtn={onClickStyleClipAddBtn}
          onClickHistory={onClickHistory}
          onClickShare={onClickShare}
          eventType={eventType}
          isLogin={isLogin || false}
          historyBtnRs={historyBtnRs}
        />
      )}
    </S.SubLayout>
  );
};

export default memo(SubLayout);
